<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-server-config">
    <div
      :class="['sky-server-config__item', 'sk-font--B', isFill(item) && 'active']"
      v-for="(item, index) in variableArr"
      :key="index"
    >
      <i class="el-icon-arrow-right" />
      <el-input
        placeholder="【必填】请输入名称"
        class="sky-server-config__select"
        v-model="item.softwareName"
        clearable
      ></el-input>
      <i class="el-icon-arrow-right" />
      <el-input
        placeholder="【必填】请输入软件版本"
        class="sky-server-config__select"
        v-model="item.softwareVersion"
        clearable
      ></el-input>
      <i class="sk-icon-remove sk-font--B" @click="handleDelete(index)"></i>
    </div>
    <el-button type="text" class="el-icon-plus sky-branch-pattern__add" style="margin-top:5px" @click="handleAdd">
      添加
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'

export default {
  name: 'SkyPositionSoftwareRelate',
  inject: ['rootView', 'elForm'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: [String, Array],
      default: ''
    }
  },
  data() {
    return {
      variableArr: [],
      loading: false,
      osList: [],
      productList: []
    }
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        let hasError = false
        if (this.variableArr.length) {
          for (const data of this.variableArr) {
            if (!this.isFill(data)) {
              hasError = true
              callback(new Error(this.$t('请输入未填项')))
            }
          }
        }
        if (!hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value.length) {
        this.handleFill(value)
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.softwareName && item.softwareVersion
    },
    handleAdd() {
      this.variableArr.push({
        softwareName: null
      })
    },
    handleFill(value) {
      this.variableArr = value
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 28px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
    color: #df1b1b;
    cursor: pointer;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
